// extracted by mini-css-extract-plugin
export default {"reduxState":"StateTools_reduxState__U7xiE"};